import { SPONSORS, APP_CONFIG } from '../data/constants.jsx';

const Sponsors = () => {
  // Different light colors for each sponsor card
  const cardColors = [
    {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-600',
      hoverBg: 'hover:bg-blue-100'
    },
    {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-600',
      hoverBg: 'hover:bg-green-100'
    },
    {
      bg: 'bg-purple-50',
      border: 'border-purple-200',
      text: 'text-purple-600',
      hoverBg: 'hover:bg-purple-100'
    },
    {
      bg: 'bg-pink-50',
      border: 'border-pink-200',
      text: 'text-pink-600',
      hoverBg: 'hover:bg-pink-100'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
            আমাদের স্পন্সর
          </h2>
          <p className="text-gray-600 text-lg">
            Our Sponsors
          </p>
        </div>

        {/* Sponsors Scroll Container */}
        <div className="relative overflow-hidden">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-green-50 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-blue-50 to-transparent z-10 pointer-events-none"></div>

          {/* Auto-Scrolling Wrapper */}
          <div className="flex animate-scroll-sponsors hover:pause-animation">
            {/* First set of sponsors */}
            {SPONSORS.map((sponsor, index) => {
              const colors = cardColors[index % cardColors.length];
              return (
                <a
                  key={`sponsor-1-${index}`}
                  href={sponsor.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex-shrink-0 mx-3 w-72 ${colors.bg} ${colors.hoverBg} rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border ${colors.border}`}
                >
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                      {sponsor.name}
                    </h3>
                    <p className="text-sm text-gray-600 mb-3">
                      {sponsor.description}
                    </p>
                    <div className={`flex items-center ${colors.text} text-sm font-medium`}>
                      <span>Visit Website</span>
                      <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </div>
                  </div>
                </a>
              );
            })}

            {/* Duplicate set for seamless loop */}
            {SPONSORS.map((sponsor, index) => {
              const colors = cardColors[index % cardColors.length];
              return (
                <a
                  key={`sponsor-2-${index}`}
                  href={sponsor.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex-shrink-0 mx-3 w-72 ${colors.bg} ${colors.hoverBg} rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border ${colors.border}`}
                >
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                      {sponsor.name}
                    </h3>
                    <p className="text-sm text-gray-600 mb-3">
                      {sponsor.description}
                    </p>
                    <div className={`flex items-center ${colors.text} text-sm font-medium`}>
                      <span>Visit Website</span>
                      <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </div>
                  </div>
                </a>
              );
            })}

            {/* "Become a Sponsor" Card */}
            <a
              href={`mailto:${APP_CONFIG.contact.email}?subject=Sponsorship Inquiry`}
              className="flex-shrink-0 mx-3 w-72 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-indigo-400"
            >
              <div className="p-6 text-white">
                <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-lg mb-4">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2">
                  Become a Sponsor
                </h3>
                <p className="text-sm text-white/90 mb-3">
                  Support our mission and reach thousands of Muslims worldwide
                </p>
                <div className="flex items-center text-white font-medium text-sm">
                  <span>Contact Us</span>
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll-sponsors {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll-sponsors {
          animation: scroll-sponsors 30s linear infinite;
        }

        .hover\\:pause-animation:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Sponsors;
